import { Environment } from '../app/modules/shared/interfaces/environment.interface';

export const environment: Environment = {
  production: true,
  keycloak: {
    issuer: 'https://auth-int.cara.ch/auth/realms/public-int',
    clientId: 'forms-int',
    responseType: 'code',
    scope: 'openid profile email phone',
    requireHttps: true,
    showDebugInformation: false,
    disableAtHashCheck: false,
  },
  lmsKeycloak: {
    loginUrl: 'https://auth-int.cara.ch/auth/realms/public-int/protocol/saml/clients/dokeos',
  },
  apiBaseUrl: 'https://api-int.cara.ch',
  environment: 'staging',
  identityProviders: {
    institutionRegistration: true
  }
};
